import { motion } from 'framer-motion';
import EducatorCard from '../ui/EducatorCard';

export default function OurEducators() {
  const headshotFiles = [
    'AinnaBaluyut.jpg',
    'AliciaDulatre.jpg',
    'AmyFu.jpg',
    'DorothyGrefiel.jpg',
    'ElenaLin.jpg',
    'FortunataReyes.jpg',
    'LailethEspinosa.jpg',
    'MelissaAlaniz.jpg',
    'MontseGonzalez.jpg',
    'MykaManalili.jpg',
    'RajwinderBall.jpg',
    'RissaPacleb.jpg',
    'SteicivRodriguezOrozco.jpg',
    'SusieLeon.jpg'
  ];

  // Overrides for specific educators (title/name/room)
  // Keys are base filenames (without extension) for stable matching
  const overridesByBase: Record<string, { name?: string; title?: string; room?: string; }> = {
    FortunataReyes: {
      name: 'Ms. Fortunata Reyes',
      title: 'ECE IT Teacher',
      room: 'Seal Room'
    },
    MontseGonzalez: {
      name: 'Ms. Montserrat Gonzalez',
      title: 'ECE Assistant',
      room: 'Starfish Room'
    },
    RissaPacleb: {
      name: 'Ms. Rissa Choy',
      title: 'Head ECE IT Teacher',
      room: 'Starfish Room'
    }
  };

  const borderOptions = ['border-yellow-200', 'border-amber-200', 'border-orange-200'];
  const particleOptions = ['bg-yellow-300', 'bg-amber-300', 'bg-orange-300'];
  const bubblePalettes: string[][] = [
    ['bg-yellow-300','bg-amber-300','bg-orange-300','bg-purple-300','bg-blue-300'],
    ['bg-blue-300','bg-purple-300','bg-green-300','bg-amber-300','bg-yellow-300'],
    ['bg-green-300','bg-blue-300','bg-amber-300','bg-orange-300','bg-purple-300']
  ];

  const educators = headshotFiles.map((file, index) => {
    const base = file.replace(/\.jpg$/i, '');
    const nameWithSpaces = base.replace(/([A-Z])/g, ' $1').trim();
    const override = overridesByBase[base] || {};
    return {
      name: override.name ?? nameWithSpaces,
      title: override.title ?? 'Educator',
      room: override.room,
      photoSrc: `/images/headshots/${file}`,
      borderColor: borderOptions[index % borderOptions.length],
      particleColor: particleOptions[index % particleOptions.length],
      bubbleColors: bubblePalettes[index % bubblePalettes.length],
      delay: 0.2 + (index % 6) * 0.1
    };
  });

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-br from-amber-50 to-yellow-100">
        <div className="max-w-6xl mx-auto px-6">
          <motion.h1 
            className="text-4xl md:text-5xl font-bold text-dblue text-center mb-12"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            Our Educators
          </motion.h1>
        </div>
      </section>

      {/* Additional Info Section */}
      <section className="py-16 bg-amber-50">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.9 }}
          >
            <h2 className="text-2xl md:text-3xl font-bold text-dblue mb-6">
              Dedicated to Excellence in Early Childhood Education
            </h2>
            <p className="text-gray-600 leading-relaxed max-w-3xl mx-auto">
              Our team of qualified educators brings years of experience and passion to creating a nurturing environment 
              where children can grow, learn, and thrive. Our Early Childhood Educators (ECE) are dedicated
professionals who nurture children's growth,
inspire learning, and create supportive
environments for development and exploration
            </p>
          </motion.div>
        </div>
      </section>

             {/* Educators Cards Section */}
       <section className="py-16 bg-white">
         <div className="max-w-6xl mx-auto px-6">
           <div className="grid md:grid-cols-3 gap-8">
              {educators.map((e, idx) => (
                <EducatorCard
                  key={e.name}
                  name={e.name}
                  title={e.title}
                  room={e.room}
                  delay={e.delay}
                  borderColor={e.borderColor}
                  particleColor={e.particleColor}
                  photoSrc={e.photoSrc}
                  bubbleColors={e.bubbleColors}
                />
              ))}

           </div>
         </div>
       </section>


    </div>
  );
}
